// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".info[data-v-2038fe79]{margin-bottom:16px}.custom-page-content[data-v-2038fe79] ul li{list-style:disc}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
